import {
  Content,
  GroupField,
  KeyTextField,
  RichTextField,
} from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import styles from './rateCalculatorTextContent.module.scss';
import { Simplify } from '../../../../../prismicio-types';
import { BulletIcons } from '@/assets';

interface RateCalculatorTextContentProps {
  title: RichTextField;
  subtitle: KeyTextField;
  advantagesHeading: KeyTextField;
  advantages: GroupField<
    Simplify<Content.RateCalculatorSliceDefaultPrimaryAdvantagesItem>
  >;
  isVisible: boolean;
}

const components: JSXMapSerializer = {
  heading2: ({ children }) => <h2 className={styles.title}>{children}</h2>,
};

export const RateCalculatorTextContent = ({
  advantages,
  advantagesHeading,
  subtitle,
  title,
  isVisible,
}: RateCalculatorTextContentProps) => {
  const isVisibleStyles = isVisible ? styles.isVisible : '';

  return (
    <article className={styles.wrapper}>
      <div className={`${styles.title_wrapper} ${isVisibleStyles}`}>
        <PrismicRichText field={title} components={components} />
      </div>
      <p className={`${styles.subtitle} ${isVisibleStyles}`}>{subtitle}</p>
      <p className={`${styles.heading} ${isVisibleStyles}`}>
        {advantagesHeading}
      </p>
      <ul className={styles.list}>
        {advantages.map((advantage, index) => (
          <li
            className={`${styles.list_item} ${isVisibleStyles}`}
            key={advantage.item}
            style={{ transitionDelay: `${index * 0.13}s` }}
          >
            <BulletIcons icon="check" /> <span>{advantage.item}</span>
          </li>
        ))}
      </ul>
    </article>
  );
};
